import { Button, Stack, Typography, useMediaQuery } from '@mui/material'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useWrapperStore } from '../../store/storeWrapper'
import { theme } from '../../theme'

export const AssistantConnectDialog = ({
    open,
    handleClose,
    handleSubmit,
    assistant,
    handleNewReply,
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { checkIsFreeAssistant, freeAssistant, buyAssistantSubscription, fetchAssistantSubscriptions } = useWrapperStore(
        (state) => state,
    )

    const handleClickBuySubmit = async () => {
        await buyAssistantSubscription(assistant.id)
        await fetchAssistantSubscriptions()
        await handleClose()
        await handleNewReply()
    }
    return (
        <ModalDialogWrapper
            footerActions={
                <>
                    <Stack
                        direction={isMobile ? 'column' : 'row'}
                        spacing={1}
                        sx={{ width: '100%'  }}>
                        <Button variant="outlined" fullWidth onClick={handleClose}>
                            Отменить
                        </Button>
                        <Button variant="contained" onClick={handleClickBuySubmit} fullWidth>
                            Подключить подписку
                        </Button>
                    </Stack>
                </>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={`Подключить подписку на ассистента  "${assistant.name}"`}>
            {freeAssistant ? (
                <Typography>
                    Первый месяц использования бесплатный. Далее с баланса будет списываться 100
                    коинов в месяц. Подписка продляется автоматически. Отключить её можно в любой
                    момент
                </Typography>
            ) : (
                <>
                    <Typography>
                        Для активации подписки с баланса будет списываться {assistant?.price} коинов
                        в месяц. Подписка продляется автоматически.
                    </Typography>
                    <Typography>Отключить её можно в любой момент</Typography>
                </>
            )}
        </ModalDialogWrapper>
    )
}
